import React, { useState } from 'react';
import Listbox from '@visa/vds/listbox';
import ListboxItem from '@visa/vds/listbox-item';
import ListboxItemContainer from '@visa/vds/listbox-item-container';
import ButtonIcon from '@visa/vds/button-icon';
import Icon from '@visa/vds/icon';
import NavMenu from '@visa/vds/navmenu';
import Button from '@visa/vds/button';
import { addMenuItem } from '_helpers/NavHelper';
import { useAuthContextUser } from '../context/AuthContext';

const MCSMobileNav = (props) => {
  const user = useAuthContextUser();
  const [navmenuOpen, setNavmenuOpen] = useState(false);

  const handleNavMenuClick = (navMenuId) => {
    var menuBtn = document.getElementById(navMenuId);
    menuBtn.click();
  }

  const renderRoutes = () => {
    let routes = props.siteRoutes;
    let render = [];
    //find out key
    routes.forEach((item, k) => {
      if (addMenuItem(item, user)) {
        var filterChildren = [];
        if (item.children) {
          filterChildren = item.children.filter((childItem, index) => {
            return addMenuItem(childItem, user);
          });
        }
        if (filterChildren.length > 0) {
          render.push(renderMenuWithChild(item, k, filterChildren));
        } else {
          render.push(<ListboxItem key={k} role="none">
            <ListboxItemContainer>
              <a href={item.redirect}>{item.menuLabel}</a>
            </ListboxItemContainer>
          </ListboxItem>);
        }
      }
    });
    return render;
  }

  const renderMenuWithChild = (menuItem, menuKey, childItems)=>{
    return (
      <ListboxItem key={menuKey} role="none" onClick={() => handleNavMenuClick("nav-dropdown-" + menuKey)}>
        <NavMenu
          id={"nav-dropdown-children-" + menuKey}
          className="dropdown-menu vds-listbox-item-container"
          menu={
            <Listbox>
              {childItems.map((child, k) => (
                !child.hidden &&
                <ListboxItem key={k} k={k} role="none">
                  <ListboxItemContainer>
                    <a href={child.redirect}>{child.menuLabel}</a>
                  </ListboxItemContainer>
                </ListboxItem>
              ))}
            </Listbox>
          }
          placement="bottom-start"
          role="navigation"
          tag="nav"
        >
          <Button flippable
            className=""
          >
            <div className='dropdown-menu-text'>
              {menuItem.menuLabel}
            </div>
            <Icon name="arrow-expand" resolution="tiny" />
          </Button>
        </NavMenu>
      </ListboxItem>
    )
  }

  return (
    <NavMenu
      aria-label="Mobile Navigation"
      className='vds-nav-mobile'
      menu={
        <Listbox>
          {renderRoutes()}
        </Listbox>
      }
      placement="bottom-start"
      role="navigation"
      tag="nav"
      handleToggle={(event, state) => {
        setNavmenuOpen(state);
      }}
      handleClose={event => {
        setNavmenuOpen(false);
      }}
    >
      <ButtonIcon ariaLabel="menu" iconType="light">
        <Icon name={navmenuOpen ? 'close' : 'menu'} resolution="low" />
      </ButtonIcon>
    </NavMenu>
  )
}

export default MCSMobileNav